import { css } from '@emotion/react';
import { SmallModeSummaryCard } from '@frontend/analytics-shared';
import { useTranslation } from '@frontend/i18n';
import { formatters, humanizeSeconds } from '@frontend/shared';
import { useNavigate } from '@frontend/weave-router';
import { theme } from '@frontend/theme';
import { useFetchAggregatedCallsSummary } from '../hooks/use-fetch-aggregated-calls-summary';
import { usePhoneAnalyticsShallowStore } from '../hooks/use-phone-analytics-store';

interface Props {
  aggregatedCallSummary?: ReturnType<typeof useFetchAggregatedCallsSummary>;
}

export const SmallModeSummaryCards = ({ aggregatedCallSummary = {} }: Props) => {
  const { t } = useTranslation('analytics-phone');
  const { filters } = usePhoneAnalyticsShallowStore('filters');
  const isOpenHoursOnly = filters?.open_office;
  const { data, isLoading } = aggregatedCallSummary;
  const navigate = useNavigate();

  return (
    <section css={styles.wrapper}>
      <SmallModeSummaryCard
        iconName='phone-small'
        isLoading={isLoading}
        onClick={() => {
          navigate({
            to: '/analytics/phone/call-volume',
          });
        }}
        summary={
          isOpenHoursOnly
            ? [{ label: t('Incoming'), value: formatters.value(data?.totalCalls?.inbound) }]
            : [
                { label: t('Incoming'), value: formatters.value(data?.totalCalls?.inbound) },
                { label: t('Outgoing'), value: formatters.value(data?.totalCalls?.outbound) },
              ]
        }
        title={t('Call Volume')}
        trackingId='phone-analytics-small-mode-call-volume'
      />
      <SmallModeSummaryCard
        iconName='phone-call'
        isLoading={isLoading}
        onClick={() => {
          navigate({
            to: '/analytics/phone/call-duration',
          });
        }}
        summary={[
          {
            label: t('Long Duration Calls'),
            value: humanizeSeconds(data?.callDuration?.avg),
          },
        ]}
        title={t('Avg Call Duration')}
        trackingId='phone-analytics-small-mode-call-duration'
      />
    </section>
  );
};

const styles = {
  wrapper: css`
    display: flex;
    gap: ${theme.spacing(2)};
    flex-wrap: wrap;
    margin-bottom: ${theme.spacing(2)};
  `,
};
